import * as React from 'react';
import * as I18n from 'i18n-js';

import UrlHelpers from './url_helpers';

import * as appleBadgeDe from '../../../images/app-store-badges/apple-app-store-de.svg';
import * as googleBadgeDe from '../../../images/app-store-badges/google-play-store-de.svg';
import * as appleBadgeEn from '../../../images/app-store-badges/apple-app-store-en.svg';
import * as googleBadgeEn from '../../../images/app-store-badges/google-play-store-en.svg';
import * as appleBadgeEs from '../../../images/app-store-badges/apple-app-store-es.svg';
import * as googleBadgeEs from '../../../images/app-store-badges/google-play-store-es.svg';
import * as appleBadgeFr from '../../../images/app-store-badges/apple-app-store-fr.svg';
import * as googleBadgeFr from '../../../images/app-store-badges/google-play-store-fr.svg';
import * as appleBadgeIt from '../../../images/app-store-badges/apple-app-store-it.svg';
import * as googleBadgeIt from '../../../images/app-store-badges/google-play-store-it.svg';
import * as appleBadgeJa from '../../../images/app-store-badges/apple-app-store-ja.svg';
import * as googleBadgeJa from '../../../images/app-store-badges/google-play-store-ja.svg';

const LOCALE_TO_APPLE_BADGE = {
  de: appleBadgeDe,
  en: appleBadgeEn,
  es: appleBadgeEs,
  fr: appleBadgeFr,
  it: appleBadgeIt,
  ja: appleBadgeJa,
};

const LOCALE_TO_GOOGLE_BADGE = {
  de: googleBadgeDe,
  en: googleBadgeEn,
  es: googleBadgeEs,
  fr: googleBadgeFr,
  it: googleBadgeIt,
  ja: googleBadgeJa,
};

interface IProps {
  userLocale: string;
}

export function AppleAppStoreLink(props: IProps) {
  const appleImage = LOCALE_TO_APPLE_BADGE[props.userLocale.slice(0, 2)] || appleBadgeEn;

  return (
    <a
      className="d-inline-block"
      href={`${UrlHelpers.appleAppStorePath}?pt=2069466&ct=logged-out-homepage-app-badge&mt=8`}
    >
      <img
        className="d-block width-100"
        src={appleImage}
        alt={I18n.t('discovery.getTheApp.iosAlt')}
      />
    </a>
  );
}

export function GooglePlayStoreLink(props: IProps) {
  const googleImage = LOCALE_TO_GOOGLE_BADGE[props.userLocale.slice(0, 2)] || googleBadgeEn;
  const params = '&utm_source=reverb_website&utm_campaign=feed_app_download&utm_medium=website_banner&utm_content=logged-out-homepage-app-badge';

  return (
    <a
      className="d-inline-block"
      href={
        `${UrlHelpers.googlePlayStorePath}${params}`}
    >
      <img
        className="d-block width-100"
        src={googleImage}
        alt={I18n.t('discovery.getTheApp.androidAlt')}
      />
    </a>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shared/app_store_links.tsx